import React, { useEffect } from "react";
import { Modal, Box, Text } from "@mantine/core";
import useStyles from "./style";
import CloseCircle from "../CloseCircle";
import { useSelector } from "react-redux";

const Header = ({ onClose, billingServices }) => {
  const { classes } = useStyles();
  return (
    <>
      <CloseCircle onclose={onClose} />
      <Box className={classes.header}>
        <Text>
          Do you want to add a{" "}
          {billingServices ? "billing note?" : "new essential support note?"}
        </Text>
      </Box>
    </>
  );
};

const AddEssentialNote = ({
  openModal,
  setOpenModal,
  onConfirm,
  billingServices,
  setBillingServices,
  // selectedPatient,
  // setSelectedPatient,
}) => {
  // console.log("🚀 ~ selectedPatient:", selectedPatient)
  const { classes } = useStyles();
  const { profile } = useSelector((state) => state.profile);
  let isBillingService = profile?.user?.billingAgree;

  // useEffect(() => {
  //   setSelectedPatient(selectedPatient);
  // }, [selectedPatient]);

  return (
    <>
      <Modal
        centered
        size={600}
        shadow="md"
        zIndex={1000}
        radius={"lg"}
        opened={openModal}
        onClose={() => setOpenModal(false)}
        overlayProps={{ blur: 3 }}
        className={classes.medicationModal}
        closeButtonProps={{ visible: false }}
      >
        <Header
          onClose={() => setOpenModal(false)}
          billingServices={billingServices}
        />
        {/* Modal content */}
        <Box className={classes.buttonsParent}>
          <button
            className={classes.addLater}
            onClick={() => {
              if (!billingServices) {
                setOpenModal(false);
                if (isBillingService) {
                  setTimeout(() => {
                    setOpenModal(true);
                    setBillingServices("billing");
                  }, 1000);
                }
              } else {
                setOpenModal(false);
              }
            }}
          >
            No, Add Later
          </button>
          <button className={classes.addEssential} onClick={onConfirm}>
            Yes, Add{" "}
            {billingServices ? "billing note?" : "essential support note?"}
          </button>
        </Box>
      </Modal>
    </>
  );
};

export default AddEssentialNote;
